/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Generate_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Generate activation code" |
*
* @param {Offline_Activation_Generate_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_generate_aria_label = /** @type {((inputs?: Offline_Activation_Generate_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Generate_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generer le code d'activation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivierungscode generieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Genera codice di attivazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сгенерировать код активации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generar código de activación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("生成激活码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーションコードを生成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्टिवेशन कोड जनरेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerar código de ativação")
	return /** @type {LocalizedString} */ ("Generate activation code")
});